import React, { Component } from 'react';

class Report extends Component {

  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      tab: 'list',
      selectedSchool: 'All',
      schools: null,
      importDone: false
    }

    Promise.all([
      import('pdfmake/build/pdfmake.js'),
      import('pdfmake/build/vfs_fonts.js')
    ]).then(imports=>{
      this.pdfMake = imports[0];
      this.pdfFonts = imports[1];
      this.pdfMake.vfs = this.pdfFonts.pdfMake.vfs;
      this.setState({importDone: true})
    })

    fetch('/api/order/list',{credentials: 'include'})
      .then(res => {
        if(res.ok)
          return res.json()
        else
          throw new Error('Network response was not ok.');
      })
      .then(x=>{

        var items = {}
        x.forEach((order)=>{
          order.items.forEach(item=>{
            items[order.school] = items[order.school] || {};
            items[order.school][item.time] = items[order.school][item.time] || {};
            items[order.school][item.time][item.name] = items[order.school][item.time][item.name] || 0;
            items[order.school][item.time][item.name] += item.count;
          })
        })

        this.setState({
          orders: x,
          items: items,
          schools: this.orderSchools(x)
        })
      })
      .then(()=>console.log('newState', this.state))
      .catch(error=> {
        console.log('error', error);
        this.setState({error: error.toString()})
      });
  }

  makePdf(e){
    e.preventDefault();

    var rows = []
    this.ordersItems().forEach(order=>{
      rows.push([
        {
          border: [true, true, true, !order.notes],
          text: (order.order_id + " " + (order.phone || '')) || ''
        }, {
          border: [true, true, true, !order.notes],
          text: order.school || ''
        },{
          border: [true, true, true, !order.notes],
          text: order.time || ''
        },{
          border: [true, true, true, !order.notes],
          text: order.classroom || ''
        },{
          border: [true, true, true, !order.notes],
          text: order.person || ''
        },{
          border: [true, true, true, !order.notes],
          text: order.order || ''
        }
      ])
      if(order.notes)
        rows.push([{
          text: 'Notes: ' + order.notes,
          colSpan: 6,
          fillColor: '#eeeeee',
          border: [true, false, true, true],
        },{},{},{}])
    });

    var doc = {
      content: [
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: [ '10%', '15%', '10%', '7%', '20%', '38%' ],

            body: [
              [
                { text:'Order ID', bold: true },
                { text:'School', bold: true },
                { text:'Time', bold: true },
                { text:'Class', bold: true },
                { text:'Student', bold: true },
                { text:'Items', bold: true }
              ],
              ...rows
            ]
          }
        }
      ]
    };

    this.pdfMake.createPdf(doc).open();
  }

  makeSummaryPdf(e){
    e.preventDefault();

    let rows = [];

    Object.entries(this.itemCounts()).forEach((school, i)=>{
      var schoolRow = { text: school[0], fontSize: 25, margin: [0, 40, 0, 10] }
      if(i !== 0){
        schoolRow.pageBreak = 'before'
      }
      rows.push(schoolRow)
      Object.entries(school[1]).forEach((time, i)=>{
        rows.push({ text: time[0], fontSize: 20, margin: [0, 40, 0, 10] })
        rows.push({
          table: {
            headerRows: 1,
            widths: [ '*', '*' ],
            body: [
              [ { text: 'Item', bold: true }, { text: 'Count', bold: true } ],
              ...Object.entries(time[1])
            ]
          }
        })
      })
    })

    var doc = {
      content: rows
    };

    this.pdfMake.createPdf(doc).open();
  }

  filteredOrders(){
    if(this.state.selectedSchool === 'All')
      return this.state.orders;
    return this.state.orders.filter(order=>
      order.school === this.state.selectedSchool);
  }

  filteredItems(){
    var school = this.state.selectedSchool;
    if(school === 'All')
      return this.state.items;

    var filtered = {};
    filtered[school] = this.state.items[school];
    return filtered;
  }

  orderSchools(orders){
    var schools = {}
    orders.forEach(order=>
      order.items.forEach(item=>{
        if(item.person)
          schools[item.person.school.name] = 1
      })
    )
    return Object.keys(schools);
  }

  setTab(tab, e){
    e.preventDefault();
    this.setState({tab: tab});
  }

  handleChange(e){
    this.setState({[e.target.name]: e.target.value});
  }

  ordersItems(){
    var orders = this.state.orders,
        lines = []

    orders.forEach(function(order){
      var newLines = []
      order.items.forEach(function(item){
        newLines.push({
          phone: order.phone,
          order_id: order.id,
          school: item.person && item.person.school.name,
          classroom: item.person && item.person.classroom.name,
          person: item.person && item.person.name,
          order: item.name + ' x ' + item.count,
          time: item.time,
          notes: order.notes
        })
      })
      lines.push(...newLines.sort((a,b) => {
        if(a.school === b.school)
          return a.person > b.person
        return a.school > b.school
      }))
    })

    if(this.state.selectedSchool === 'All')
    return lines

    return lines.filter(line=>
      line.school === this.state.selectedSchool);
  }

  itemCounts(){
    var counts = {}
    this.state.orders.forEach(order=>{
      order.items.forEach(item=>{

        // DOnt add it if wrong school
        if(this.state.selectedSchool !== 'All' && item.person.school.name !== this.state.selectedSchool) return;

        var school = counts[item.person.school.name] = counts[item.person.school.name] || {}
        var time = school[item.time] = school[item.time] || {}
        time[item.name] = (time[item.name] || 0) + item.count
      })
    })
    return counts
  }

  render() {
    var orderItems = this.ordersItems()
    if(!this.state.importDone) return (<h1>Loading...</h1>);
    return (
      <div className="container">

        <div className="hidden-print">
          <br />
          <ul className="nav nav-tabs">
            <li role="presentation" className={this.state.tab === 'list' ? "active" : ''}>
              <a href="" onClick={this.setTab.bind(this, 'list')}>
                Order List
              </a>
            </li>
            <li role="presentation" className={this.state.tab === 'labels' ? "active" : ''}>
              <a href="" onClick={this.setTab.bind(this, 'labels')}>
                Individual Labels
              </a>
            </li>
            <li role="presentation" className={this.state.tab === 'items' ? "active" : ''}>
              <a href="" onClick={this.setTab.bind(this, 'items')}>
                Item Totals
              </a>
            </li>
          </ul>
        </div>

        { this.state.schools ? (
          <div className="hidden-print">
            <br />
            <select className="form-control"
              onChange={this.handleChange.bind(this)}
              name="selectedSchool"
              value={this.state.selectedSchool}>
                <option>All</option>
                {this.state.schools.map(school=>(
                  <option key={school}>{school}</option>
                ))}
            </select>
          </div>
        ) : null }

        { this.state.tab === 'list' ? (
          <div>
            <h1 className="hidden-print">Order List</h1>
            <a href="" onClick={this.makePdf.bind(this)}>Printable PDF</a>

            <table className="table">
              <thead>
                <tr>
                  <th>ID<br />Phone</th>
                  <th>School</th>
                  <th>Time</th>
                  <th>Class</th>
                  <th>Student</th>
                  <th>Items</th>
                </tr>
              </thead>
              <tbody>
                { orderItems.map((item, i)=>{
                  var prevOrderDifferent = (i === 0 || (orderItems[i-1].order_id !== item.order_id)),
                      nextOrderDifferent = (i === (orderItems.length - 1) || (orderItems[i+1].order_id !== item.order_id)),
                      key = i

                  var row = [
                    <tr key={key}>
                      {prevOrderDifferent ? <td>{item.order_id}<br />{item.phone}</td> : <td></td>}
                      <td>{item.school}</td>
                      <td>{item.time}</td>
                      <td>{item.classroom}</td>
                      <td>{item.person}</td>
                      <td>{item.order}</td>
                    </tr>
                  ]
                  if(item.notes && nextOrderDifferent)
                    row.push(
                      <tr key={i + '-notes'}>
                        <td colSpan="3"></td>
                        <td>Order {item.order_id} Notes:</td>
                        <td>
                          {item.notes}
                        </td>
                      </tr>
                    )
                  return row
                }) }
              </tbody>
            </table>
          </div>
        ) : null }

        { this.state.tab === 'labels' ? (
          <div>
            <h1 className="hidden-print">
              Order Labels
            </h1>
            <p className="hidden-print">Printable PDF:</p>
            <p className="hidden-print">
              <a target="blank" className="btn btn-default btn-sm" href={
                "/api/pdf/labels" + (this.state.selectedSchool === 'All' ?
                  '' : '?school='+this.state.selectedSchool)
              }>1 Up</a> <a target="blank" className="btn btn-default btn-sm" href={
                "/api/pdf/labels?up=2" + (this.state.selectedSchool === 'All' ?
                  '' : '&school='+this.state.selectedSchool)
              }>2 Up</a> <a target="blank" className="btn btn-default btn-sm" href={
                "/api/pdf/labels?up=4" + (this.state.selectedSchool === 'All' ?
                  '' : '&school='+this.state.selectedSchool)
              }>4 Up</a>
            </p>
            { orderItems.length } Orders to print
          </div>
        ) : null }

        { this.state.tab === 'items' ? (
          <div>
            <h1 className="hidden-print">
              Item Counts
            </h1>
            <a href="" onClick={this.makeSummaryPdf.bind(this)}>Printable PDF</a>

            { Object.entries(this.itemCounts()).map((school, i)=>(
              <div key={i} style={{pageBreakAfter: 'always'}}>
                <h1>{school[0]}</h1>
                { Object.entries(school[1]).map((time, i)=>(
                  <div key={i}>
                    { time[0] !== 'null' ? <h2>{time[0]}</h2> : null }
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(time[1]).map(item=>(
                          <tr key={item[0]}>
                            <td>{item[0]}</td>
                            <td>{item[1]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            ))}

          </div>
        ) : null }

      </div>
    );
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/pages/Report.js